<template>
    <div>
        <div v-for="(user,index) in userList" v-if="userList.length > 0">
            <Form :ref="'user'+index" :model="userList[index]" :rules="formRule" :inline="true">
                <Row :gutter="36">

                    <Col span="4">
                        <FormItem label="姓名" prop="username" style="width: 100%;">
                            <Input v-model="user.username" placeholder="请填写姓名"></Input>
                        </FormItem>
                    </Col>

                    <Col span="4">
                        <FormItem label="手机号" prop="tkphone" style="width: 100%">
                            <Input v-model="user.tkphone" placeholder="请填写手机号"></Input>
                        </FormItem>
                    </Col>

                    <Col span="4">
                        <FormItem label="部门" prop="company_group_id" style="width: 100%">
                            <Select clearable v-model="user.company_group_id" placeholder="请选择部门">
                                <Option v-for="group in groupList" :value="group.id" :key="group.id" :label="group.name"></Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="3" v-if="userList.length > 1">
                        <FormItem>
                            <label slot="label">&nbsp;</label>
                            <Button type="default" class="remove-btn" style="background-color: #fff" @click="deleteOne(index)">删除</Button>
                        </FormItem>
                    </Col>
                </Row>
            </Form>
        </div>

        <div class="add-more">
            <Row>
                <Col span="4">
                    <label class="add-more-label">添加</label>
                </Col>
                <Col span="8">
                    <Input v-model="addNum" style="width: 60px"></Input>
                </Col>
                <Col span="6">
                    <label class="add-more-label">名用户</label>
                </Col>
                <Col span="6">
                    <Button type="default" class="add-one-btn" @click="addMoreUsers">确定</Button>
                </Col>
            </Row>
        </div>
    </div>
</template>

<script>
    import addMemberValidate from "@/validateRule/company/addMember";
    import utils from "@/utils";
    import $api from "@/service/index";

    export default {
        data(){
            return {
                userList :[{
                    "username"          :   "",     // username用户名
                    "tkphone"           :   "",     // tkphone手机号
                    "company_group_id"  :   "",     // company_group_id所属部门id
                }],
                //添加_名用户
                addNum : "",
                //部门列表
                groupList : [],
                //验证规则
                formRule : addMemberValidate,
            }
        },
        created(){
            this.getGroupList();
        },
        methods : {
            //获取部门列表
            getGroupList(){
                let _self = this;
                $api.getCompanyUserGroup("group").then(data=>{
                    _self.groupList = data;
                });
            },
            //添加用户
            addMoreUsers(){
                if(!this.addNum || this.addNum === "" || this.addNum === "0" || this.addNum === 0){
                    return false;
                }
                let _self = this;
                let reg = /^\+?[1-9][0-9]*$/;
                if(!_self.addNum.match(reg)){
                    utils.notice("请填写正整数","error");
                    return false;
                }
                for (let i = 0;i<parseInt(this.addNum);i++){
                    let item = {
                        "username"          :   "",     // username用户名
                        "tkphone"           :   "",     // tkphone手机号
                        "company_group_id"  :   "",     // company_group_id所属部门id
                    };
                    this.userList.push(item);
                    this.userList = [].concat(this.userList);
                }
            },
            /**
             * 删除一个
             * @param {int} index 待删除项的索引
             */
            deleteOne(index){
                this.userList.splice(index,1);
            },
            //获取结果
            getData(){
                let res = true;
                for(let i = 0 ; i < this.userList.length; i++){
                    this.$refs["user"+i][0].validate((valid) => {
                        if (!valid) {
                            res = false;
                        }
                    })
                }
                if(!res){
                    utils.notice("您还有信息未填写或未验证通过","error");
                    return false;
                }
                return this.userList;
            },
            //重置表单
            resetForm(){
                //写这么多步置空为了保证提交后表单验证的触发时机正确
                this.addNum = "";
                this.formRule = {};
                this.userList = [];
                this.formRule = addMemberValidate;
                this.$nextTick(()=>{
                    this.userList = [].concat({
                        "username"          :   "",     // username用户名
                        "tkphone"           :   "",     // tkphone手机号
                        "company_group_id"  :   "",     // company_group_id所属部门id
                    });
                })

            }
        }
    }
</script>

<style scoped>
@import "addGroupMember.less";
</style>
<style>
    /*此style所有内容必须包裹_add_member_send_msg_checkbox以防css污染*/
    ._add_member_send_msg_checkbox .ivu-checkbox-wrapper{
        padding-top: 2px;
    }
    ._add_member_send_msg_checkbox .ivu-checkbox-wrapper .ivu-checkbox-inner{
        width : 20px ;
        height: 20px;
    }
    ._add_member_send_msg_checkbox .ivu-checkbox-checked .ivu-checkbox-inner:after{
        top : 2px;
        left: 6px;
        width: 6px;
        height: 12px;
    }
</style>


// WEBPACK FOOTER //
// src/pages/company/addMember/business/AddGroupMember.vue